import React, { useState, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { usePermissions } from 'react-admin';
import { useTranslate, useLogout } from 'react-admin';
import SubMenu from './SubMenu'
import { Box, Typography } from '@material-ui/core';
import icCluster from '../assets/icons/ic_cluster.png';
import icServer from '../assets/icons/ic_server_light.png';
import icSystemSetup from '../assets/icons/ic_system_setup_light.png';
import icContentManagement from '../assets/icons/ic_content_management_light.png';
import icMaintaince from '../assets/icons/ic_maintaince.png';
import icActionSetting from '../assets/icons/ic_actions_setting.png';
import SubChildren from './SubChildrenMenu'
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { pathName } from '../role/actions';
import colors from '../CustomizedUIs/Colors';
import FileDialog from '../file-management/file-management-dialog';
// const MenuName = 'clusters' | 'contents' | 'systems' | 'hardwares' | 'maintenances' | 'shortcuts' | 'adminUsers' | 'systemData' | 'channel' | 'media';

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        maxWidth: 360,
        position: 'relative',
        overflow: 'auto',
        padding: 0,
        maxHeight: '90vh'

    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    menuIcon: {
        width: 24,
        height: 24
    },
    listItem: {
        height: 50,
        backgroundColor: theme.menu.color.item,
        borderBottomColor: 'rgb(255, 255, 255,0.1)'
    },
    selected: {
        backgroundColor: theme.menu.color.selected,
        borderLeft: 'solid 4px white'
    },
    listChildItem: {
        height: 50,
        borderBottomColor: theme.palette.grey[200],
        backgroundColor: 'white',
        borderLeft: `solid 4px ${theme.palette.secondary.main}`,
    },
    childItemselected: {
        borderLeft: `solid 4px white`,
        borderBottomColor: theme.palette.grey[200],
        backgroundColor: 'white',
    },
    TitleChildSubMenu: {
        fontFamily: 'UniviaPro',
        fontSize: '12px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: theme.menu.color.subItem,
    },
    TitleSubMenu: {
        fontFamily: 'UniviaPro',
        fontSize: '12px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#ffffff',
    }
}));

const CustomListItem = ({ name, path, isHidden, onClick }) => {
    const history = useHistory();
    const classes = useStyles();
    const dispatch = useDispatch();
    const role = useSelector((state) => state.role);
    const pathname = useSelector((state) => state.path_name);
    const is_blocking = useSelector((state) => state.is_blocking);
    const handleClick = () => {
        if (onClick) return onClick();


        if (is_blocking === false) {
            history.push(path);
            dispatch(pathName('roles'))
        }
        else {
            history.replace(path);
            dispatch(pathName(path))
        }
    }

    const isSelected = history.location.pathname === path
        || (history.location.pathname.includes('/Entity') && path === '/dashboard')
        || (history.location.pathname.includes('/Cluster') && path === '/dashboard')
        || (history.location.pathname.toUpperCase().includes('/InfoChannel'.toUpperCase()) && path.toUpperCase() === '/InfoChannel'.toUpperCase())
        || (history.location.pathname.toUpperCase().includes('/Remote'.toUpperCase()) && path.toUpperCase() === '/Remote'.toUpperCase())
        || (history.location.pathname.toUpperCase().includes('/Keymap'.toUpperCase()) && path.toUpperCase() === '/Remote'.toUpperCase())
        || (history.location.pathname.toUpperCase().includes('/DeviceFirmware'.toUpperCase()) && path.toUpperCase() === '/DeviceFirmware'.toUpperCase())
        || (history.location.pathname.toUpperCase().includes('/ClientDevice'.toUpperCase()) && path.toUpperCase() === '/ClientDevice'.toUpperCase())
        || (history.location.pathname.toUpperCase().includes('/DeviceProfiles'.toUpperCase()) && path.toUpperCase() === '/DeviceProfiles'.toUpperCase())



    const listItemStyles = isSelected ? classNames(classes.listItem, classes.selected) : classes.listItem;

    if (isHidden) return null
    return (
        <Box borderBottom={1} display='flex' alignItems='center' className={listItemStyles}>
            <ListItem
                button
                onClick={handleClick}
                style={{ height: 50 }}
            >
                <ListItemText primary={<Typography className={classes.TitleSubMenu}>{name}</Typography>} />
            </ListItem>
        </Box>
    )
}

const CustomChildListItem = ({ name, path, isHidden }) => {
    const history = useHistory();
    const classes = useStyles();
    const dispatch = useDispatch()
    const role = useSelector((state) => state.role);
    const pathname = useSelector((state) => state.path_name);
    const is_blocking = useSelector((state) => state.is_blocking);
    const handleClick = () => {
        if (is_blocking === false) {
            history.push(path);
            dispatch(pathName('roles'))
        }
        else {
            history.replace(path);
            dispatch(pathName(path))
        }
    }

    const isSelected = history.location.pathname === path
        || (history.location.pathname.includes('/Entity') && path === '/dashboard')
        || (history.location.pathname.includes('/Cluster') && path === '/dashboard')
        || (history.location.pathname.toUpperCase().includes('/Users'.toUpperCase()) && path.toUpperCase() === '/Users'.toUpperCase())
        || (history.location.pathname.toUpperCase().includes('/Roles'.toUpperCase()) && path.toUpperCase() === '/Roles'.toUpperCase())
        || (history.location.pathname.toUpperCase().includes('/Channel'.toUpperCase()) && path.toUpperCase() === '/Channel'.toUpperCase())
        || (history.location.pathname.toUpperCase().includes('/Media'.toUpperCase()) && path.toUpperCase() === '/Media'.toUpperCase())
        || (history.location.pathname.toUpperCase().includes('/ExternalService'.toUpperCase()) && path.toUpperCase() === '/ExternalService'.toUpperCase());

    const listItemStyles = isSelected ? classes.childItemselected : classes.listChildItem;
    if (isHidden) return null
    return (
        <Box borderBottom={1} display='flex' alignItems='center' className={listItemStyles}>
            <ListItem
                button
                onClick={handleClick}
                style={{ height: 50 }}
            // component="a"
            // href={'/#' + path}
            >
                <ListItemText style={{ marginLeft: 10 }} primary={<Typography className={classes.TitleChildSubMenu}>{name}</Typography>} />
            </ListItem>
        </Box>
    )
}

const Menu = ({ dense, logout }) => {
    const classes = useStyles();
    const history = useHistory();
    const translate = useTranslate();
    const { permissions, loaded } = usePermissions();
    const handleLogout = useLogout();
    const open = useSelector((state) => state.admin.ui.sidebarOpen);
    useSelector((state) => state.theme);
    const [state, setState] = useState({
        clusters: false,
        contents: false,
        systems: false,
        hardwares: false,
        maintenances: false,
        calendar: false,
        shortcuts: false,

    });
    const [childrenState, setChildrenState] = useState({
        adminUsers: false,
        systemData: false,
        channel: false,
        media: false,
        externalService: false
    })
    const categoryId = localStorage.getItem('categoryId') ? parseInt(localStorage.getItem('categoryId')) : 1;
    const [categoryDefaultId, setCategoryDefaultId] = useState(categoryId);
    const [showingFileDialog, setShowingFileDialog] = useState(false);

    const onSubMenuClick = (menu,dashboard) => {
        let body = {
            clusters: false,
            contents: false,
            systems: false,
            hardwares: false,
            maintenances: false,
            calendar: false,
            shortcuts: false,
        }
        body[menu] = !state[menu]
        setState(body);
        setChildrenState({
            adminUsers: false,
            systemData: false,
            channel: false,
            media: false,
        });
        if (dashboard) {
            let checkLocation = false
            // if (window.location.hash.includes('Alarm')) {
            //     checkLocation = true
            // }
            // if (window.location.hash.includes('Mailbox')) {
            //     checkLocation = true
            // }
            // if (window.location.hash.includes('UsageData')) {
            //     checkLocation = true
            // }
            // if (window.location.hash.includes('Commerce')) {
            //     checkLocation = true
            // }
            if (window.location.hash.includes('dashboard')) {
                checkLocation = true
            }
            if (!checkLocation) {
                history.push('/dashboard')
            }
        }
    }

    const onSubChildMenuClick = (menu) => {
        setChildrenState({ ...childrenState, [menu]: !childrenState[menu] });
    }
    if (!localStorage.getItem('userData')) return handleLogout

    return loaded ? (
        <Fragment>
            <List
                component="nav"
                aria-labelledby="nested-list-subheader"
                className={classes.root}>
                <SubMenu
                    name={translate(`pos.menu.clusterAndService`)}
                    icon={<img src={icCluster} className={classes.menuIcon} />}
                    open={state.clusters}
                    handleClick={() => onSubMenuClick('clusters',true)}
                >
                    <CustomListItem
                        name={translate(`pos.menu.general`)}
                        path="/dashboard"
                        sidebarIsOpen={open}
                        dense={dense}
                    />
                    <CustomListItem
                        isHidden={permissions && !permissions.functionAction.find((value) => value.function === 'Messages' && (value.isRead || value.isUpdate))}
                        name={translate(`pos.menu.mailBox`)}
                        path="/Mailbox"
                        sidebarIsOpen={open}
                        dense={dense}
                    />
                    <CustomListItem
                        isHidden={permissions && !permissions.functionAction.find((value) => value.function === 'Alarms' && (value.isRead || value.isUpdate))}
                        name={translate(`pos.menu.alarm`)}
                        path="/Alarm"
                        sidebarIsOpen={open}
                        dense={dense}
                    />
                    <CustomListItem
                        isHidden={permissions && !permissions.functionAction.find((value) => value.function === 'Commerce' && (value.isRead || value.isUpdate))}
                        name={translate(`pos.menu.commerce`)}
                        path="/Commerce"
                        sidebarIsOpen={open}
                        dense={dense}
                    />
                    <CustomListItem
                        isHidden={permissions && !permissions.functionAction.find((value) => value.function === 'Usage data' && (value.isRead || value.isUpdate))}
                        name={translate(`pos.menu.usageData`)}
                        path="/UsageData"
                        sidebarIsOpen={open}
                        dense={dense}
                    />
                </SubMenu>
                <SubMenu
                    name={translate(`pos.menu.contentManagement`)}
                    icon={<img src={icContentManagement} className={classes.menuIcon} />}
                    open={state.contents}
                    handleClick={() => onSubMenuClick('contents')}
                >
                    {
                        permissions && permissions.functionAction.find((value) => value.function === 'Channels and programs' && (value.isRead || value.isUpdate)) &&
                        <SubChildren
                            name={translate(`pos.menu.channelProgram`)}
                            open={childrenState.channel}
                            handleClick={() => onSubChildMenuClick('channel')}
                        >
                            <CustomChildListItem
                                name={translate(`pos.menu.channelManagement`)}
                                path="/Channel"
                                sidebarIsOpen={open}
                                dense={dense}
                            />
                            <CustomChildListItem
                                name={translate(`pos.menu.channelCategory`)}
                                path="/Categorychannel"
                                sidebarIsOpen={open}
                                dense={dense}
                            />
                            <CustomChildListItem
                                name={translate(`pos.menu.channelGroup`)}
                                path="/groupchannel"
                                sidebarIsOpen={open}
                                dense={dense}
                            />
                        </SubChildren>
                    }
                    {
                        permissions && permissions.functionAction.find((value) => value.function === 'Media' && (value.isRead || value.isUpdate)) &&
                        <SubChildren
                            name={'Media'}
                            open={childrenState.media}
                            handleClick={() => onSubChildMenuClick('media')}
                        >
                            <CustomChildListItem
                                name={translate(`pos.menu.Movies`)}
                                path="/Media"
                                sidebarIsOpen={open}
                                dense={dense}
                            />
                            <CustomChildListItem
                                name={translate(`pos.channels.categories`)}
                                path="/CategoryMedia"
                                sidebarIsOpen={open}
                                dense={dense}
                            />
                        </SubChildren>
                    }
                    <SubChildren
                        name={'External service & program'}
                        open={childrenState.externalService}
                        handleClick={() => onSubChildMenuClick('externalService')}
                    >
                        <CustomChildListItem
                            name={'External service'}
                            path="/ExternalService"
                            sidebarIsOpen={open}
                            dense={dense}
                        />
                        <CustomChildListItem
                            name={translate(`pos.channels.categories`)}
                            path="/CategoryService"
                            sidebarIsOpen={open}
                            dense={dense}
                        />
                    </SubChildren>

                    <CustomListItem
                        isHidden={permissions && !permissions.functionAction.find((value) => value.function === 'Info channel (Management)' && (value.isRead || value.isUpdate))}
                        name={translate(`pos.menu.infoChannelManagement`)}
                        path="/InfoChannel"
                        sidebarIsOpen={open}
                        dense={dense}
                    />
                    <CustomListItem
                        isHidden={permissions && !permissions.functionAction.find((value) => value.function === 'Info pages' && (value.isRead || value.isUpdate))}
                        name={translate(`pos.menu.infoPage`)}
                        path="/InfoPage"
                        sidebarIsOpen={open}
                        dense={dense}
                    />
                    <CustomListItem
                        isHidden={permissions && !permissions.functionAction.find((value) => value.function === 'File manager (CRUD)' && (value.isRead || value.isUpdate))}
                        name={translate(`pos.menu.fileManager`)}
                        path=""
                        sidebarIsOpen={open}
                        dense={dense}
                        onClick={() => setShowingFileDialog(true)}
                    />

                </SubMenu>
                <SubMenu
                    name={translate(`pos.menu.systemSetup`)}
                    icon={<img src={icSystemSetup} className={classes.menuIcon} />}
                    open={state.systems}
                    handleClick={() => onSubMenuClick('systems')}
                >
                    {
                        permissions && permissions.functionAction.find((value) => value.function === 'Admin users' && (value.isRead || value.isUpdate)) &&
                        (
                            <SubChildren
                                name={translate(`pos.menu.adminUsers`)}
                                open={childrenState.adminUsers}
                                handleClick={() => onSubChildMenuClick('adminUsers')}
                            >
                                <CustomChildListItem
                                    isHidden={permissions && !permissions.functionAction.find((value) => value.function === 'Admin rights/functions' && (value.isRead || value.isUpdate))}
                                    name={translate(`pos.menu.userAdministration`)}
                                    path="/users"
                                    sidebarIsOpen={open}
                                    dense={dense}
                                />

                                <CustomChildListItem
                                    isHidden={permissions && !permissions.functionAction.find((value) => value.function === 'Admin users' && (value.isRead || value.isUpdate))}
                                    name={translate(`pos.menu.roles`)}
                                    path="/roles"
                                    sidebarIsOpen={open}
                                    dense={dense}
                                />
                            </SubChildren>
                        )
                    }

                    {
                        permissions && permissions.functionAction.find((value) => value.function === 'System Data' && (value.isRead || value.isUpdate)) &&
                        (
                            <SubChildren
                                name={translate(`pos.menu.systemData`)}
                                open={childrenState.systemData}
                                handleClick={() => onSubChildMenuClick('systemData')}
                            >
                                <CustomChildListItem
                                    name={translate(`pos.menu.serverStatus`)}
                                    path="/ServerStatus"
                                    sidebarIsOpen={open}
                                    dense={dense}
                                />

                                <CustomChildListItem
                                    isHidden={permissions && !permissions.functionAction.find((value) => value.function === 'Log' && (value.isRead || value.isUpdate))}
                                    name={translate(`pos.menu.serverLog`)}
                                    path="/Serverlog"
                                    sidebarIsOpen={open}
                                    dense={dense}
                                />
                            </SubChildren>
                        )
                    }
                    <CustomListItem
                        isHidden
                        // isHidden={permissions && permissions.name !== 'Sysadmin'}
                        name={translate(`pos.settings.title`)}
                        path="/settings"
                        sidebarIsOpen={open}
                        dense={dense}
                    />
                    <CustomListItem
                        isHidden={permissions && permissions.name !== 'Sysadmin'}
                        name={translate(`pos.support.menu`)}
                        path="/supporter"
                        sidebarIsOpen={open}
                        dense={dense}
                    />
                     <CustomListItem
                        isHidden={permissions && permissions.name !== 'Sysadmin'}
                        name={translate(`pos.settings.title`)}
                        path="/settings"
                        sidebarIsOpen={open}
                        dense={dense}
                    />
                </SubMenu>
                <SubMenu
                    name={translate(`pos.menu.hardwareSetup`)}
                    icon={<img src={icServer} className={classes.menuIcon} />}
                    open={state.hardwares}
                    handleClick={() => onSubMenuClick('hardwares')}
                >
                    <CustomListItem
                        isHidden={permissions && !permissions.functionAction.find((value) => value.function === 'Devices and profiles' && (value.isRead || value.isUpdate))}
                        name={translate(`pos.menu.deviceProfile`)}
                        path="/DeviceProfiles"
                        sidebarIsOpen={open}
                        dense={dense}
                    />
                    <CustomListItem
                        isHidden={permissions && !permissions.functionAction.find((value) => value.function === 'Client devices' && (value.isRead || value.isUpdate))}
                        name={translate(`pos.menu.clientDevice`)}
                        path="/ClientDevice"
                        sidebarIsOpen={open}
                        dense={dense}
                    />
                    <CustomListItem
                        isHidden={permissions && !permissions.functionAction.find((value) => value.function === 'Remote FirmWare' && (value.isRead || value.isUpdate))}
                        name={'Device Firmware'}
                        path="/DeviceFirmware"
                        sidebarIsOpen={open}
                        dense={dense}
                    />
                    <CustomListItem
                        isHidden={permissions && !permissions.functionAction.find((value) => value.function === 'TV’s and remote control' && (value.isRead || value.isUpdate))}
                        name={translate(`pos.menu.remoteTv`)}
                        path="/Remote"
                        sidebarIsOpen={open}
                        dense={dense}
                    />
                </SubMenu>
                <SubMenu
                    name={translate(`pos.menu.maintenance`)}
                    icon={<img src={icMaintaince} className={classes.menuIcon} />}
                    open={state.maintenances}
                    handleClick={() => onSubMenuClick('maintenances')}
                >
                    <CustomListItem
                        name={translate(`pos.menu.messageTemplates`)}
                        path="/MessageTemplate"
                        sidebarIsOpen={open}
                        dense={dense}
                    />
                    <CustomListItem
                        name={translate(`pos.menu.emailTest`)}
                        path="EmailTest"
                        sidebarIsOpen={open}
                        dense={dense}
                    />

                </SubMenu>
                {
                      permissions && (permissions.name === 'Sysadmin' || permissions.name === 'Admin') &&
                    <SubMenu
                        name={translate(`pos.menu.calendar`)}
                        icon={<img src={icActionSetting} className={classes.menuIcon} />}
                        open={state.calendar}
                        handleClick={() => onSubMenuClick('calendar')}
                    >
                    
                            <CustomListItem
                                name={translate(`pos.menu.calendarType`)}
                                path="/calendarType"
                                sidebarIsOpen={open}
                                dense={dense}
                            />  
                    </SubMenu>
                }    
            </List>
            <FileDialog
                pickerMode={'menu'}
                defaultId={categoryDefaultId}
                setCategoryDefaultId={(id) => {
                    setCategoryDefaultId(id);
                    localStorage.setItem('categoryId', id);
                }}
                open={showingFileDialog}
                handleClose={() => setShowingFileDialog(false)}
                isPermission={permissions && permissions.functionAction.find((value) => value.function === 'File manager (CRUD)' && (value.isRead || value.isUpdate))}
            />
        </Fragment>
    ) : null;
}
export default Menu
